import React, {useState} from 'react';
import {Link} from "react-router-dom";
import {connect} from "react-redux";
import { invitationReady } from '~/helpers/invitation';
import TextTranslate from '../../../TextTranslate/TextTranslate';

const RsvpButton = (props) => {

    if (!props.invitation) {
        return <></>;
    }

    if (props.invitation.rsvp_status === 'pending') {
        return (
            <Link to="/confirm" className="btn btn-primary btn-sm">
                <TextTranslate name="word-rsvp-now" fallback="RSVP NOW" textOnly/>
            </Link>
        );
    }

    if (props.invitation.rsvp_status === 'declined') {
        return (
            <button disabled={true} className="btn btn-secondary btn-sm">
                <TextTranslate name="invitation-status-declined" fallback="Invitation Declined" textOnly/>
            </button>
        );
    }

    if (props.invitation.registration_status === 'pending') {
        return (
            <Link to="/registration" className="btn btn-primary btn-sm">
                <TextTranslate name="invitation-status-start-reg" fallback="Start Registration" textOnly/>
            </Link>
        );
    }

    if (props.invitation.registration_status === 'in_progress') {

        const ready = invitationReady(props.guests);

        if (ready) {
            return (
                <Link to="/preview" className="btn btn-primary btn-sm">
                    <TextTranslate name="word-review-submit" fallback="Review & Submit" textOnly/>
                </Link>
            );
        }

        return (
            <Link to="/registration" className="btn btn-primary btn-sm">
                <TextTranslate name="word-continue-registration" fallback="Continue Registration" textOnly/>
            </Link>
        );
    }

    if (props.invitation.registration_status === 'submitted') {
        return (
            <Link to="/preview" className="btn btn-primary btn-sm">
                <TextTranslate name="word-registration-submitted" fallback="Registration Submitted" textOnly/>
            </Link>
        );
    };

    return <></>;
}

const mapStateToProps = (state) => ({
    invitation: state.invitation.data,
    guests: state.guests?.list
});

export default connect(mapStateToProps)(RsvpButton);
